module.exports = __webpack_public_path__ + "img/battletrip_section5.636a33c0.jpg";